import { Avatar, Button } from '@mui/material'
import React, { useState } from 'react'
import '../Postbox.css'
import { db } from '../Firebase/init'
import { collection, addDoc } from 'firebase/firestore'

function Postbox() {
    const[tweet, setTweet] = useState('');
    const[image, setImage] = useState('');

    async function postTweet(event) {
        event.preventDefault();
        const newTweet = {
            avatar: 'https://cdn.pfps.gg/pfps/8458-funny-cat-16.png',
            displayName: 'New Poster',
            userName: 'newposter123',
            verified: false,
            caption: tweet,
            media: image,
        }
        await addDoc(collection(db, 'posts'), newTweet);
        /* ###again normally this is not how we'd do it but since our collection has just 1 thing so we dont need its reference, and can just target posts. this is essentially updateDoc and is not how we do it in other normal dbs */
        setTweet('');
        setImage('');
    } 

  return (
    <div className='postbox'>
        <form>
            <div className="postbox__input">
            <Avatar src='https://i.redd.it/2mxejivbvvf61.jpg' />
            <input onChange={event => setTweet(event.target.value)} value = {tweet} type="text" placeholder="What's happening?" />
            </div>
            <input onChange={event => setImage(event.target.value)} value = {image}className="postbox__imageInput"placeholder='Enter any Image URL' />
            <Button type="submit" onClick={(event) => postTweet(event)} className="post__button">Post</Button>
        </form>
    </div>
  )
}

export default Postbox